import {
    Box,
    Button,
    Container, Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    Typography
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import '../../styles/manage.scss';
import {AddIcon as AddIconMui, FolderIcon, TaskLoading} from "../../icons";
import SendIcon from "@mui/icons-material/Send";
import AddIcon from '@mui/icons-material/Add';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import Profile from "../../component/tool_bar/profile";
import {createBoard, deleteBoardList, updateBoardName, batchMoveBoardsToAlbum} from "../../api/boardManage";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, RootState, store} from "../../store";
import {fetchBoardListAsync, setSelectBoardType} from "../../store/boardSlice";
import {fetchAlbumListAsync} from "../../store/albumSlice";
import {deleteLocalStorage, getLocalConversionId, setLocalStorage} from "../../util/storage";
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import {boardPutProps} from "../../types/board.types";
import { useTranslation } from 'react-i18next'
import Album from "./Album";
import AlbumChoice from "./AlbumChoice";
import {
    coverSelectCanvasImage,
    removeLoadingImage,
    setGlobalMessage,
    setSelectCanvasImage,
    setSnackbarOpen
} from "../../store/taskSlice";
import {uploadLocalImage} from "../../api/common";
import CancelIcon from "@mui/icons-material/Cancel";
import {setScreenPosition} from "../../store/drawSlice";
import {useGaEvents} from "../../hooks/useGaEvents";
import { useResolvedCoverImage } from '../../hooks/useResolvedCoverImage';
import { useThemeImage } from '../../hooks/useThemeImage';
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";


function BoardCoverImg({ cover }: { cover?: string | null }) {
    const emptyCover = useThemeImage('emptyBoardCover');
    return (
        <img
            className="board-img"
            src={cover ?? emptyCover}
            alt=''
            loading="lazy"
        />
    );
}

export default function Project() {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const albumId = queryParams.get('albumId');

    const [createLoading, setCreateLoading] = useState(false)

    const dispatch: AppDispatch = useDispatch();

    const { t } = useTranslation()

    const { sentOpenCanvasEvent, sentCreateCanvasEvent, sentDeleteCanvasEvent } = useGaEvents();

    const {trackBoardSelectionPopupShow, trackEnterBoard, trackBoardDeleteConfirm, trackBoardRenameConfirm, trackBoardDelete, trackBoardRename, trackBoardMenuClick, trackMoveBoardClick, trackMoveBoardConfirm, trackSelectBoardClick, trackBoardSpaceClick} = useMatomoTrackingPoint()

    const boardList = useSelector((state: RootState) => state.board.boardList);
    const boardLastFetchedAt = useSelector((state: RootState) => state.board.lastFetchedAt);
    const albumList = useSelector((state: RootState) => state.album.albumList);
    const selectedAlbum = albumId ? albumList.find(a => a.albumId === albumId) ?? null : null;

    const selectCanvasImage = useSelector((state: RootState) => state.task.canvasImage);

    const [open, setOpen] = React.useState(false);

    const [deleteBoard, setDeleteBoard] = React.useState('')

    const [openFormDialog, setOpenFormDialog] = React.useState(false);

    const [boardMenu, setBoardMenu] = React.useState<{ boardId: string; top: number; left: number } | null>(null);
    const [moveDialogOpen, setMoveDialogOpen] = React.useState(false);
    const [moveBoardIds, setMoveBoardIds] = React.useState<string[]>([]);
    const moveConfirmedRef = useRef(false);
    const [selectMode, setSelectMode] = React.useState(false);
    const [selectedBoardIds, setSelectedBoardIds] = React.useState<string[]>([]);

    const [messages, setMessages] = useState<Array<{text: string, isUser: boolean}>>([]);

    const [updateBoard, setUpdateBoard] = React.useState<boardPutProps | null>(null)

    const fileInputRef = useRef<HTMLInputElement>(null);

    const inputRef = useRef<HTMLDivElement>(null);

    const [message, setMessage] = useState("");

    const handleLocalUploadClick = () => {
        fileInputRef.current?.click();
    };

    const handleClickOpenFormDialog = (board: boardPutProps) => {
        setOpenFormDialog(true);
        setUpdateBoard(board)
    };

    const handleCloseFormDialog = () => {
        trackBoardRenameConfirm({
            page_id: window.location.href,
            board_id: updateBoard?.boardId || '',
            switch_status: 'cancel'
        })
        setOpenFormDialog(false);
    };
    
    const handleClickOpen = (boardId: string) => {
        setOpen(true);
        setDeleteBoard(boardId)
    };

    const temporary_url = process.env.REACT_APP_PROXY_TARGET ?? ''

    const handleClose = () => {
        setOpen(false);
        trackBoardDeleteConfirm({
            page_id: window.location.href,
            board_id: deleteBoard,
            switch_status: 'cancel'
        })
        setDeleteBoard('')
    };

    const handleBoardMoreClick = (e: React.MouseEvent, boardId: string) => {
        e.stopPropagation();
        trackBoardMenuClick({ page_id: window.location.href, board_id: boardId });
        const btn = e.currentTarget.querySelector('.board-more-btn') as HTMLElement | null;
        if (!btn) return;
        const rect = btn.getBoundingClientRect();
        setBoardMenu({
            boardId,
            top: rect.bottom + 4,
            left: rect.left + rect.width - 156
        });
    };

    const handleBoardMenuClose = () => {
        setBoardMenu(null);
    };

    const handleMoveBoard = async (albumId: string | null) => {
        if (moveBoardIds.length === 0) return;
        moveConfirmedRef.current = true;
        try {
            await batchMoveBoardsToAlbum(moveBoardIds, albumId);
            trackMoveBoardConfirm({ page_id: window.location.href, board_id: moveBoardIds.join(','), switch_status: 'confirm' });
            dispatch(fetchBoardListAsync());
            dispatch(fetchAlbumListAsync());
            setSelectMode(false);
            setSelectedBoardIds([]);
        } catch {
            // ignore
        }
    };

    useEffect(() => {
        if (boardMenu) {
            const handler = () => handleBoardMenuClose();
            document.addEventListener('click', handler);
            return () => document.removeEventListener('click', handler);
        }
    }, [boardMenu]);

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (files && files.length > 0) {
            const totalLoadings = Array.from(files).map(item => 'loading');
            dispatch(setSelectCanvasImage(totalLoadings));
            try {
                const uploadPromises = Array.from(files).map(file =>
                    uploadLocalImage('current-client-id', file)
                );

                const responses = await Promise.all(uploadPromises);

                const validUrls = responses
                    .filter(res => res)
                    .map(res => (res as any).lod0);

                if (validUrls.length > 0) {
                    dispatch(removeLoadingImage(validUrls.length))
                    dispatch(setSelectCanvasImage(validUrls));
                }

            } catch (error) {
                dispatch(removeLoadingImage(files.length))
                console.error(t('upload_failed'), error);
            }
        }
    };

    const deleteBoardFun = () => {
        trackBoardDeleteConfirm({
            page_id: window.location.href,
            board_id: deleteBoard,
            switch_status: 'confirm'
        })

        deleteBoardList(deleteBoard).then(item=>{
            dispatch(fetchBoardListAsync())
            setOpen(false);
            setDeleteBoard('');
            sentDeleteCanvasEvent({board_id: deleteBoard})
        })
    }

    const updateBoardFun = () => {
        if (!updateBoard) return
        updateBoardName(updateBoard).then(item=>{
            dispatch(fetchBoardListAsync())
            setOpenFormDialog(false);
            trackBoardRenameConfirm({
                page_id: window.location.href,
                board_id: updateBoard.boardId,
                switch_status: 'confirm'
            })
        })
    }

    const createNewBoard = () => {
        if (createLoading) return
        setCreateLoading(true);
        createBoard({boardType: "inspireBoard"}).then(async (item) => {
            if (item?.boardId && albumId) {
                try {
                    await batchMoveBoardsToAlbum([item.boardId], albumId);
                } catch {}
            }
            changeBoard(item?.boardId, item?.boardType)
            setCreateLoading(false)
            dispatch(fetchBoardListAsync())
            sentCreateCanvasEvent({board_id: item?.boardId as string})
            trackEnterBoard({
                page_id: window.location.href,
                board_id: item?.boardId,
                board_type: 'inspireBoard'
            })
        })
    }

    const changeBoard = (boardId?: string, boardType?: "moodBoard" | "inspireBoard") => {
        sentOpenCanvasEvent({board_id: boardId as string})
        setLocalStorage('boardId', boardId);
        const inspireQuery = boardType === 'inspireBoard' ? '&inspire=1' : '';
        navigate(`/?boardId=${boardId}${inspireQuery}`);
    }

    useEffect(() => {
        deleteLocalStorage('conversionId')
        dispatch(fetchBoardListAsync())
        dispatch(fetchAlbumListAsync())
    }, []);

    // 画板列表超时(30秒测试值)自动刷新：记录每次发起拉取时间，鼠标移动时距上次超过30秒则重新拉取
    const BOARD_LIST_REFRESH_MS = 30 * 1000;
    const boardLastFetchedAtRef = useRef(boardLastFetchedAt);
    const boardRefreshingRef = useRef(false);
    useEffect(() => {
        boardLastFetchedAtRef.current = boardLastFetchedAt;
    }, [boardLastFetchedAt]);
    useEffect(() => {
        const handleBoardListRefreshByMouseMove = () => {
            if (boardRefreshingRef.current) return;
            const lastFetchedAt = boardLastFetchedAtRef.current;
            // lastFetchedAt 为 0 表示尚未发起过拉取，交给挂载 effect 处理，避免重复请求
            if (!lastFetchedAt) return;
            if (Date.now() - lastFetchedAt < BOARD_LIST_REFRESH_MS) return;
            boardRefreshingRef.current = true;
            dispatch(fetchBoardListAsync())
                .catch(() => { /* 失败时静默，boardSlice.rejected 已记录 */ })
                .finally(() => {
                    boardRefreshingRef.current = false;
                });
        };
        window.addEventListener('mousemove', handleBoardListRefreshByMouseMove);
        return () => window.removeEventListener('mousemove', handleBoardListRefreshByMouseMove);
    }, [dispatch]);

    const handleSend = () => {
        if (message.trim() || selectCanvasImage?.length) {
            const isLoading = selectCanvasImage?.find(item => item === 'loading')
            if (isLoading) {
                store.dispatch(setSnackbarOpen({open: true, message: t('uploading_images_remaining')}))
                setTimeout(()=>{
                    store.dispatch(setSnackbarOpen({open: false, message: ''}))
                }, 2000)
                return
            }
            setMessages([...messages, { text: message, isUser: true }]);
            setMessage("");

            dispatch(setGlobalMessage(message))
            createNewBoard()
        }
    };

    const handleKeyPress = useCallback((e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
            const textareaElement = inputRef.current?.querySelector('textarea');
            textareaElement?.blur();
        }
    }, [handleSend]);

    return (
        <React.Fragment>
            <Box>
                <div className="manage-header">
                    <div className="pc-only" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {albumId ? (
                            <>
                                <span className="project-title-main" style={{ cursor: 'pointer', color: albumId ? 'var(--c-text-secondary)' : 'var(--c-text-primary)' }} onClick={() => { trackBoardSpaceClick({ page_id: window.location.href, switch_from: 'file_path' }); navigate('/dashboard'); }}>绘板空间</span>
                                <span style={{ color: 'var(--c-text-secondary)', fontSize: 20 }}>&gt;</span>
                                <span className="project-title-main" style={{marginLeft: 0}}>{selectedAlbum?.albumName || '...'}</span>
                            </>
                        ) : (
                            <span className="project-title-main">绘板空间</span>
                        )}
                    </div>
                    <div className="profile-right flex-col-reverse"><Profile/></div>
                </div>
                <div className='mobile-only project-title-mobile'>
                    {albumId ? (
                        <>
                            <span style={{ cursor: 'pointer', color: 'var(--c-text-secondary)' }} onClick={() => { trackBoardSpaceClick({ page_id: window.location.href, switch_from: 'file_path' }); navigate('/dashboard'); }}>绘板空间</span>
                            <span style={{ color: 'var(--c-text-secondary)', margin: '0 4px' }}>&gt;</span>
                            <span style={{ color: 'var(--c-text-primary)' }}>{selectedAlbum?.albumName || '...'}</span>
                        </>
                    ) : '绘板空间'}
                </div>

                {!albumId && <Album onAlbumClick={(id) => navigate(`/dashboard?albumId=${id}`)} />}


                <Box>
                    {!albumId && <div className="board-section-title">{t('PROJECTS')}</div>}
                    <div className={`board-list ${selectedAlbum ? 'board-list-album' : 'board-list-top'}`}>
                        <div className='createBoard' onClick={() => {
                            trackBoardSelectionPopupShow({board_selection_from: albumId ? 'file' : 'management_page'})
                            // dispatch(setSelectBoardType(true))
                            createNewBoard()
                        }}>
                            {createLoading && <TaskLoading size={30}/>}
                            {
                                !createLoading && <>
                                    <AddIcon className="add-icon-big"/>
                                    <div>{t('create_new_board')}</div>
                                </>
                            }
                        </div>
                        {
                            (selectedAlbum ? boardList.filter(b => b.albumId === albumId) : boardList.filter(b => !b.albumId)).map((_, index) => {
                                const isSelected = selectedBoardIds.includes(_.boardId);
                                return (
                                <div className='borderCard' key={index} onClick={() => {
                                    if (selectMode) {
                                        setSelectedBoardIds(prev =>
                                            isSelected ? prev.filter(id => id !== _.boardId) : [...prev, _.boardId]
                                        );
                                        return;
                                    }
                                    trackEnterBoard({
                                        page_id: window.location.href,
                                        board_id: _.boardId,
                                        board_type: _.boardType
                                    })
                                    changeBoard(_.boardId, _.boardType)
                                }}>
                                    {selectMode && (
                                        <div className={`board-checkbox ${isSelected ? 'checked' : ''}`}>
                                            {isSelected && <span className="board-checkbox-check">✓</span>}
                                        </div>
                                    )}
                                    <div
                                        className={`board-type-tag board-type-${_.boardType === 'inspireBoard' ? 'inspire' : 'mood'}`}>
                                        {_.boardType === 'inspireBoard' ? '故事绘板' : '探索绘板'}
                                    </div>
                                    <BoardCoverImg cover={_.coverImage}/>
                                    {!selectMode && (
                                        <div className="board-more" onClick={(e) => handleBoardMoreClick(e, _.boardId)}>
                                            <div className="board-more-btn">
                                                <MoreVertIcon sx={{ fontSize: 22, color: 'var(--c-text-tertiary)' }} />
                                            </div>
                                        </div>
                                    )}
                                    <div className="board-title">
                                        <div>{_.boardName}</div>
                                    </div>
                                    <div className="board-time">{_.createdAt}</div>
                                </div>
                                );
                            })
                        }
                    </div>

                    {/* 画板更多菜单 */}
                    {boardMenu && (
                        <div
                            className="board-dropdown-menu"
                            style={{position: 'fixed', top: boardMenu.top, left: boardMenu.left, zIndex: 1300}}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="board-dropdown-item" onClick={() => {
                                const board = boardList.find(b => b.boardId === boardMenu.boardId);
                                if (!board) return;
                                setBoardMenu(null);
                                trackBoardRename({
                                    page_id: window.location.href,
                                    board_id: board.boardId
                                })
                                handleClickOpenFormDialog({newName: board.boardName, boardId: board.boardId})
                            }}>
                                <DriveFileRenameOutlineOutlinedIcon sx={{fontSize: 18, color: 'var(--c-text-primary)'}}/>
                                <span>重命名</span>
                            </div>
                            <div className="board-dropdown-item" onClick={() => {
                                const id = boardMenu.boardId;
                                setBoardMenu(null);
                                trackMoveBoardClick({page_id: window.location.href, board_id: boardMenu.boardId});
                                setMoveBoardIds([id]);
                                setMoveDialogOpen(true);
                            }}>
                                <FolderOpenOutlinedIcon sx={{fontSize: 18, color: 'var(--c-text-primary)'}}/>
                                <span>移动到...</span>
                            </div>
                            <div className="board-dropdown-item" onClick={() => {
                                setBoardMenu(null);
                                trackSelectBoardClick({page_id: window.location.href, board_id: boardMenu.boardId});
                                setSelectMode(true);
                                setSelectedBoardIds([]);
                            }}>
                                <CheckCircleOutlineOutlinedIcon sx={{fontSize: 18, color: 'var(--c-text-primary)'}}/>
                                <span>选择绘板</span>
                            </div>
                            <div className="board-dropdown-item" onClick={() => {
                                setBoardMenu(null);
                                trackBoardDelete({
                                    page_id: window.location.href,
                                    board_id: boardMenu.boardId
                                })
                                handleClickOpen(boardMenu.boardId)
                            }}>
                                <DeleteOutlineIcon sx={{fontSize: 18, color: 'var(--c-text-primary)'}}/>
                                <span>删除绘板</span>
                            </div>
                        </div>
                    )}

                    {selectMode && (
                        <div className="board-select-bar">
                            <div className="board-select-bar-inner">
                                <div className="board-select-all" onClick={() => {
                                    const currentList = selectedAlbum ? boardList.filter(b => b.albumId === albumId) : boardList.filter(b => !b.albumId);
                                    if (selectedBoardIds.length === currentList.length) {
                                        setSelectedBoardIds([]);
                                    } else {
                                        setSelectedBoardIds(currentList.map(b => b.boardId));
                                    }
                                }}>
                                    <div className={`board-select-all-box ${
                                        selectedBoardIds.length === 0 ? '' :
                                        selectedBoardIds.length === (selectedAlbum ? boardList.filter(b => b.albumId === albumId).length : boardList.filter(b => !b.albumId).length) ? 'checked' : 'indeterminate'
                                    }`}>
                                        {selectedBoardIds.length === (selectedAlbum ? boardList.filter(b => b.albumId === albumId).length : boardList.filter(b => !b.albumId).length)
                                            ? <span className="board-select-all-check">✓</span>
                                            : selectedBoardIds.length > 0
                                            ? <span className="board-select-all-minus">−</span>
                                            : null}
                                    </div>
                                    <span className="board-select-all-text">全选</span>
                                </div>

                                <span className="board-select-count">已选择 {selectedBoardIds.length}/{selectedAlbum ? boardList.filter(b => b.albumId === albumId).length : boardList.filter(b => !b.albumId).length} 个绘板</span>

                                <div className={`board-select-move ${selectedBoardIds.length === 0 ? 'disabled' : ''}`} onClick={() => {
                                    if (selectedBoardIds.length === 0) return;
                                    trackMoveBoardClick({ page_id: window.location.href, board_id: selectedBoardIds.join(',') });
                                    setMoveBoardIds(selectedBoardIds);
                                    setMoveDialogOpen(true);
                                }}>
                                    <FolderIcon />
                                    <span className="board-select-move-text">移动到...</span>
                                </div>

                                <div className="board-select-close" onClick={() => {
                                    setSelectMode(false);
                                    setSelectedBoardIds([]);
                                }}>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path d="M14.25 3.75L3.75 14.25M3.75 3.75L14.25 14.25" stroke="var(--c-text-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    )}
                </Box>
            </Box>
            <Dialog open={openFormDialog} onClose={handleCloseFormDialog}>
                <DialogTitle>{t('edit_board_name')}</DialogTitle>
                <DialogContent sx={{ paddingBottom: 0 }}>
                    <DialogContentText>
                        {t('board_name_change_tip')}
                    </DialogContentText>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="name"
                        name="board name"
                        label={t('board_name')}
                        type="text"
                        onChange={(e)=>{updateBoard && setUpdateBoard({...updateBoard, newName: e.target.value})}}
                        value={updateBoard?.newName}
                        fullWidth
                        variant="standard"
                    />
                    <DialogActions>
                        <Button onClick={handleCloseFormDialog}>{t('cancel')}</Button>
                        <Button type="submit" onClick={updateBoardFun}>{t('confirm')}</Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t('delete_board_confirm')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button style={{color: 'gray'}} onClick={handleClose}>{t('cancel')}</Button>
                    <Button onClick={deleteBoardFun} color="error">
                        {t('delete')}
                    </Button>
                </DialogActions>
            </Dialog>

            <AlbumChoice
                open={moveDialogOpen}
                onClose={() => {
                    if (!moveConfirmedRef.current) {
                        trackMoveBoardConfirm({ page_id: window.location.href, board_id: moveBoardIds.join(','), switch_status: 'cancel' });
                    }
                    moveConfirmedRef.current = false;
                    setMoveDialogOpen(false);
                }}
                albums={albumList}
                onMove={handleMoveBoard}
                currentAlbumId={albumId || (moveBoardIds.length === 1 ? boardList.find(b => b.boardId === moveBoardIds[0])?.albumId : undefined)}
            />
        </React.Fragment>
    );
}
